import GOSettings from './GOSettings'

export default GOSettings
